import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';
import ThemeProvider from './theme';
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { BrowserRouter } from 'react-router-dom';
import { GraphClientProvider } from './contexts/GraphClientContext';

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '';
const BACKEND_NAME = process.env.REACT_APP_BACKEND_NAME || '';

console.log('CLIENT_ID TEST:', CLIENT_ID);
console.log('BACKEND_NAME:', BACKEND_NAME);

Providers.globalProvider = new Msal2Provider({
  clientId: '651cf4be-11b5-4ca2-bb47-63b613afb424',
  scopes: [
    `api://soc-billing-api/access_as_user`,
  ],
  redirectUri: window.location.origin
});

// Providers.globalProvider = new Msal2Provider({
//   clientId: CLIENT_ID,
//   scopes: [
//     `api://soc-billing-api-stg/access_as_user`,
//   ]
// });

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Save the current path before authentication redirects
const currentPath = window.location.pathname + window.location.search;
if (currentPath !== '/' && !window.location.search.includes('code=')) {
  sessionStorage.setItem('preAuthPath', currentPath);
}

// Restore the path after authentication completes
if (window.location.pathname === '/' && sessionStorage.getItem('preAuthPath')) {
  const savedPath = sessionStorage.getItem('preAuthPath');
  sessionStorage.removeItem('preAuthPath');
  if (savedPath) {
    window.history.replaceState({}, '', savedPath);
  }
}

root.render(
  <React.StrictMode>
    <SettingsProvider>
      <ThemeProvider>
        <CollapseDrawerProvider>
          <BrowserRouter>
            <GraphClientProvider>
              <App />
            </GraphClientProvider>
          </BrowserRouter>
        </CollapseDrawerProvider>
      </ThemeProvider>
    </SettingsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
